import { IDemo, E3DDemoNameVals, DemoIds } from 'types'
import { getSharedAsset } from '../../helpers/utils'

const intro = getSharedAsset('mec-explainer-intro.mp4', 'demos', 'videos')
const video = getSharedAsset('mec-explainer.mp4', 'demos', 'videos')
const monolith = getSharedAsset('mec-explainer.png', 'demos', 'monoliths')
const poster = getSharedAsset('mec-explainer.png', 'demos', 'posters')
const nextDemoThumbnail = getSharedAsset('ice-mobility.png', 'demos', 'thumbnails')

export const mecExplainer: IDemo = {
  type: E3DDemoNameVals.mecExplainer,
  id: DemoIds.mecExplainer,
  intro,
  video,
  monolith,
  poster,
  end: {
    header: 'Harness the cloud.',
    body: `5G Edge puts the power of the cloud right into the Verizon network - bringing computing power closer to where it's needed. It's the world's first mobile edge compute platform with AWS Wavelength.`,
    nextDemoText: 'Automating quality control processes',
    nextDemoId: DemoIds.iceMobility,
    nextDemo: E3DDemoNameVals.iceMobility,
    nextDemoThumbnail,
    previousDemoId: DemoIds.indy
  }
  // ,
  // poll: {
  //   id: 'mec',
  //   header: 'How familiar are you with 5G MEC and its use cases?',
  //   qrImg: 'mecQR.png',
  //   qrText: 'Download our white paper to learn more about MEC.',
  //   options: [
  //     { label: 'Very familiar', results: 0 },
  //     { label: 'Familiar', results: 0 },
  //     { label: 'Somewhat familiar', results: 0 },
  //     { label: 'Not familiar', results: 0 }
  //   ]
  // }
}
